import { imgUrl } from '../../common/utilities/ImgUrl';
import { ConnectionCategory } from '../../dataConnection/utils/DataConnectionUtils';
import {
  classes,
  cssClass,
  flexRowStyle,
} from '../../style';
import { FlowOutputStepRunStatus } from '../../ts/models/FlowOutputStepRunInfo';
import { RunFlowTaskStatus } from '../../ts/models/RunFlowTaskInfo';
const cssPrefix = 'FlowIcon';

export const iconClass = cssClass(cssPrefix, 'icon', {
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
});
export const iconClassWithColor = cssClass(cssPrefix, 'iconWithColor', flexRowStyle, {
  flex: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  backgroundColor: '#2A5775', // temporary, until we have step colors
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
});
const iconToggleExpandUp = cssClass(cssPrefix, 'dropdownUp', {
  backgroundImage: imgUrl('expand_close.png')
});
const iconToggleExpandDown = cssClass(cssPrefix, 'dropdownDown', {
  backgroundImage: imgUrl('expand_open.png')
});
const iconInputExternalClass = cssClass(cssPrefix, 'icon_input_external', {
  backgroundImage: imgUrl('Loom_Flow_Step_Input_DS.svg'),
  borderRadius: 20,
});
const iconInputFileClass = cssClass(cssPrefix, 'icon_input_file', {
  backgroundImage: imgUrl('Loom_Flow_Step_Input_File.svg'),
  borderRadius: 20,
});
const iconOutputPublishClass = cssClass(cssPrefix, 'icon_output_publish', {
  backgroundImage: imgUrl('Loom_Flow_Step_Output_Published_DS.svg')
});
const iconOutputPublishDataRoleClass = cssClass(cssPrefix, 'icon_output_publish', {
  backgroundImage: imgUrl('Loom_Flow_Step_Output_Published_DR.svg')
});
const iconOutputFileClass = cssClass(cssPrefix, 'icon_output_file', {
  backgroundImage: imgUrl('Loom_Flow_Step_Output_File_Extract.svg')
});

export function getExpandIcon(expanded: boolean) {
  return classes(expanded ? iconToggleExpandUp : iconToggleExpandDown, iconClass);
}

export function getStepIconClass(type: 'input' | 'output', connectionCategory: ConnectionCategory, isDataRole: boolean): string {
  switch (type) {
    case 'input':
      switch (connectionCategory) {
        case 'external':
          return iconInputExternalClass;
        case 'file':
          return iconInputFileClass;
        case 'tableau':
          return iconInputExternalClass;
        case 'tableausite':
          return iconInputExternalClass;
        default:
          return iconInputExternalClass;
      }
    case 'output':
      switch (connectionCategory) {
        case 'external':
          return iconOutputPublishClass;
        case 'file':
          return iconOutputFileClass;
        case 'tableau':
          return iconOutputPublishClass;
        case 'tableausite':
          return isDataRole ? iconOutputPublishDataRoleClass : iconOutputPublishClass;
        default:
          return iconOutputPublishClass;
      }
    default:
      return '';
  }
}

export function getFlowOutputStepRunIconClass(status: string): string {
  switch (status) {
    case FlowOutputStepRunStatus.pending:
      return 'tb-prep-flow-overview-history-status-pending-icon';
    case FlowOutputStepRunStatus.inProgress:
      return 'tb-prep-flow-overview-history-status-inprogress-icon';
    case FlowOutputStepRunStatus.success:
      return 'tb-prep-flow-overview-history-status-success-icon';
    case FlowOutputStepRunStatus.failed:
      return 'tb-prep-flow-overview-history-status-failed-icon';
    case FlowOutputStepRunStatus.cancelled:
      return 'tb-prep-flow-overview-history-status-cancelled-icon';
    default:
      return 'tb-prep-flow-overview-history-status-failed-icon';
  }
}

export function getRunFlowTaskStatusIconClass(status: string): string {
  switch (status) {
    case RunFlowTaskStatus.Suspended:
      return 'tb-react-dg-hcol tb-icon-server-alert-list-suspended';
    case RunFlowTaskStatus.InProgress:
      return 'tb-prep-flow-overview-history-status-inprogress-icon';
    case RunFlowTaskStatus.Succeeded:
      return 'tb-prep-flow-overview-history-status-success-icon';
    case RunFlowTaskStatus.Failed:
      return 'tb-prep-flow-overview-history-status-failed-icon';
    case RunFlowTaskStatus.Scheduled:
    default:
      return 'tb-prep-flow-overview-history-status-pending-icon';
  }
}
